// extracted by mini-css-extract-plugin
export default {"container":"Jya4TQTw","clipPathContainer":"GMG3Qgat"};